import React from 'react'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import { gql, useQuery } from '@apollo/client'
import LinearProgress from '@material-ui/core/LinearProgress'
import Error from 'components/error'
import { useFieldArray, useFormContext } from 'react-hook-form'
import { findIndex, some } from 'lodash'
import FormSubheader from '../create-profile-form/form-subheader'
import SelectionGroup from '../create-profile-form/selection-group'
import { getSelectionGroupIcon } from '../create-profile-form/selection-group-icons'
import {
  SelectionCheckboxList,
  SelectionCheckboxOption,
} from '../create-profile-form/selection-checkbox-option'
import { useCreateProfileFieldStyles } from '../create-profile-form/field-styles'

const ServicesQuery = gql`
  query Services {
    Services {
      message
      success
      serviceTypes {
        serviceTypeId
        typeName
        description
        services {
          serviceId
          serviceName
          serviceType
        }
      }
    }
  }
`

export const Services = ({ serviceTypes, hideHeader = false }) => {
  const fieldClasses = useCreateProfileFieldStyles()
  const { register, control } = useFormContext()
  const { append, remove, fields } = useFieldArray({
    name: 'services',
    control,
  })

  const isChecked = (serviceId, checkedServices) => {
    return some(checkedServices, { serviceId })
  }

  const toggleServiceChecked = (serviceId, checkedServices) => {
    isChecked(serviceId, checkedServices)
      ? remove(findIndex(checkedServices, { serviceId }))
      : append({ serviceId })
  }

  return (
    <Box className={fieldClasses.fieldSection}>
      {hideHeader ? (
        <FormSubheader
          title="Services"
          description="Select the services you offer students."
          required
        />
      ) : (
        <Typography variant="h4" gutterBottom>
          Services *
        </Typography>
      )}
      <Box className={fieldClasses.fieldStack}>
        {serviceTypes.map(serviceType => (
          <SelectionGroup
            key={serviceType.typeName}
            title={serviceType.typeName}
            description={serviceType.description}
            icon={getSelectionGroupIcon(serviceType.typeName)}
          >
            <SelectionCheckboxList>
              {serviceType.services.map((service, i) => (
                <SelectionCheckboxOption
                  key={service.serviceId}
                  checked={isChecked(service.serviceId, fields)}
                  label={service.serviceName}
                  name={`services[${i}].serviceId`}
                  value={service.serviceId}
                  onChange={() =>
                    toggleServiceChecked(service.serviceId, fields)
                  }
                />
              ))}
            </SelectionCheckboxList>
          </SelectionGroup>
        ))}
      </Box>
      <Box display="none" aria-hidden="true">
        {fields.map((item, index) => (
          <input
            key={item.id}
            type="hidden"
            ref={register()}
            name={`services[${index}].serviceId`}
            value={item.serviceId}
          />
        ))}
      </Box>
    </Box>
  )
}

export default function Service({ hideHeader = false }) {
  const { data, loading, error } = useQuery(ServicesQuery)
  if (loading) return <LinearProgress color="primary" />
  if (error) return <Error error={error} />
  return (
    <Services
      serviceTypes={data?.Services?.serviceTypes}
      hideHeader={hideHeader}
    />
  )
}
